import { render, staticRenderFns } from "./ModalDeleteAds.vue?vue&type=template&id=02a30ee4&"
import script from "./ModalDeleteAds.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports